module.exports = __webpack_public_path__ + "static/media/user.ce9d3560.svg";